import { SecondHandSuppliesOrders } from './../../models/second-hand-supplies-orders';
import { ActivatedRoute, Router } from '@angular/router';
 // import { CancelOrderComponent } from './../../components/cancel-order/cancel-order.component';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { ChangeStatusComponent } from '../../components/change-status/change-status.component';
import { GetSecondHandSuppliesOrdersByPkService } from '../../services/get-second-hand-supplies-orders-by-pk.service';
// import { CancelOrderItemComponent } from '../../components/cancel-order-item/cancel-order-item.component';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss'],
  animations: [
    trigger("openCloseStatus", [
      state('true', style({ height: '*', opacity: '1' })),
      state('false', style({ height: '160px', opacity: '1' })),
      transition("false <=> true", [animate(500)])
    ])
  ],
})
export class ViewComponent implements OnInit {
  openStatus = false;

  oldSecondHandSuppliesOrder: SecondHandSuppliesOrders;
  constructor(
    private _dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private getSecondHandSuppliesOrdersByPkService: GetSecondHandSuppliesOrdersByPkService
  ) { }

  ngOnInit(): void {
    if(this.route.snapshot.data && this.route.snapshot.data.oldSecondHandSuppliesOrder){
      this.oldSecondHandSuppliesOrder = this.route.snapshot.data.oldSecondHandSuppliesOrder;
      console.log(this.oldSecondHandSuppliesOrder);
    }
  }
  /* cancelOrder() {
    const dialogRef = this._dialog.open ( CancelOrderComponent, {
      width: '30%',
      panelClass:'custom-modal',
      data: this.oldSupplyOrder
    });
    dialogRef.afterClosed().subscribe(data=>{
      if(data === 'yes'){
        this.getLatestOrderData();
      }
    })
  }*/
  changeStatus() {
    const dialogRef = this._dialog.open ( ChangeStatusComponent, {
      width: '60%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: this.oldSecondHandSuppliesOrder
    });
    dialogRef.afterClosed().subscribe(data=>{
      if(data === 'yes'){
        this.getLatestOrderData();
      }
    })
  }

  getLatestOrderData(){
    this.getSecondHandSuppliesOrdersByPkService.getSecondHandSuppliesOrderByPk(this.oldSecondHandSuppliesOrder.id).subscribe(data=>{
      this.oldSecondHandSuppliesOrder = data;
    })
  }
  filterToggleStatus(): void {
    this.openStatus = !this.openStatus;
  }

  viewInvoice(){
    window.open(`https://dental-360.herokuapp.com/api/v1/event/get-secondhand-invoice/${this.oldSecondHandSuppliesOrder.id}`);
  }
}
